import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-vessel-toolbar',
  templateUrl: './vessel-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AuthenticationModule]
})
export class VesselToolbarComponent {

  constructor(private _router: Router) { }

  navigateToInternalAuditPage() {
    console.log('Navigating to internal audit page');
    this._router.navigate(['vessels/vessel/internal-audit']).then(() => {
      console.log('Navigated');
    });
  }
}
